// =============================================================================
// BACKEND CONFIGURATION — SINGLE SOURCE OF TRUTH
// =============================================================================
// To switch backends, comment out the current line and uncomment another.
// Exactly ONE of the BACKEND_URL lines below may be active.
// -----------------------------------------------------------------------------

// --- Local .NET backend, HTTP (both F5 profiles listen on http://localhost:5000) ---
//export const BACKEND_URL = 'http://localhost:5000';


// --- Live / production backend ---
export const BACKEND_URL = 'https://investmentbackend.asyntexconsultancy.com';

// Derived URLs — do not edit.
export const API_BASE_URL = `${BACKEND_URL.replace(/\/+$/, '')}/api`;
export const MEDIA_BASE_URL = BACKEND_URL.replace(/\/+$/, '');
